import React from "react";
import { Row , Col, message } from "antd";
import './render-fare.style.scss';
import { EditFareComponent } from "../../edit-fare-component/edit-fare.component";
import { useState } from "react";
import { useEffect } from "react";
import { isValid, isValidArray } from "../../../utils/utilities";
import { getAPIDateFormat, isSameDate } from "../../../utils/date.utils";
import { getBusByIdAction } from "../../../actions/vechicle-actions";
const getActiveDate = (selectedDates) =>{
    return selectedDates[0];
}

export const RenderScheduleFareBlock = (props) => {

        const{
            scheduleData,
            selectedDates
        } = props;
        
        const [currentDate , setCurrentDate] = useState(null);
        const [fetchDate , setFechDate] = useState(null);
        const [busData, setBusData] = useState(scheduleData.bus);

        const onFareUpdateSuccess=()=>{
        }

        useEffect(()=>{
            if(isValidArray(selectedDates)&&selectedDates.length>0){
                setCurrentDate(getActiveDate(selectedDates));
            }
        },[selectedDates]);

        return(
            <Row gutter={[16,16]} justify="center" align="middle" flex={1}>
                <Col>
                    <EditFareComponent 
                        scheduleDescription={scheduleData.description}
                        travelDate={fetchDate}
                        scheduleId={scheduleData.id}
                        seatGroupIds={busData.seat_group_ids}
                        selectedBus={busData}
                        onFareUpdateSuccess={onFareUpdateSuccess}
                        supportedFare ={busData.supported_fare}
                        onCancel={()=>{
                        
                        }}
                        selectedDates={selectedDates}
                        showGetPriceButton={true}
                        tripDynamicPricing = {null}
                        onGetPriceClick={()=>{
                            if(isValid(currentDate)){
                                let trip = isValid(scheduleData.trips)?scheduleData.trips.find(trip => isSameDate(trip.start_date, currentDate)):null;
                                if (isValid(trip)){
                                    let tripBusId = trip.bus_id;
                                    if (tripBusId != scheduleData.bus.id){
                                        getBusByIdAction(tripBusId, (fetchedBusData) => {
                                            setBusData(fetchedBusData);
                                            setFechDate(currentDate);
                                        });
                                    }
                                    else{
                                        setFechDate(currentDate);
                                    }
                                }
                                else{
                                    setFechDate(currentDate);
                                }
                            }else{
                                message.error("Please select active date.")
                            }
                        }}
                        showTravelDate={false}
                        clientSideCheck={false}
                    />
                </Col>
            </Row>
        )
}
